﻿<script setup>
    const ver = ref('');
    async function GetVersion() {
        ver.value = (await axios.get('/api/config/getversion')).data;
    }
    GetVersion();
</script>

<template>
    <div text-center>v{{ver}}</div>
</template>